


























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { BPopover, BvEvent } from "bootstrap-vue";
import { formatPhone } from "@/utils";

@Component({
  components: {
    BPopover,
  },
  computed: mapGetters("schedule", ["checkedRows", "notRemindedRows"]),
})
export default class RemindersPopover extends Vue {
  @Prop(Boolean) readonly show!: boolean;
  id = "open-notifications-popover";
  checkedRows!: any[];
  loading = false;
  message = "";
  lang = "ES";
  langs = [{
    "lang": "ES",
    "name": "Español"
  },
  {
    "lang": "EN",
    "name": "English"
  }
  ];
  get target() {
    return this.id + "-target";
  }
  sendCalls() {
    this.$modal.show("dialog", {
      title: "SEND <b>CALL</b> OPEN NOTIFICATIONS",
      text: "Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            this.$modal.hide("dialog");
            this.loading = true;
            try {
              const { checkedRows } = this;
              for (let i = 0; i < checkedRows.length; i++) {
                const appt = checkedRows[i];
                const { id } = appt;
                try {
                  const result: string = await this.$store.dispatch(
                    "schedule/sendOpenNotificationCall",
                    { id: id, message: this.message, lang: this.lang }
                  );
                  if (result.includes("ERROR SENDING VOICE")) {
                    const error = result.split(":")[1].trim();
                    appt.reminder.error = error;
                  } else {
                    appt.reminder.sent = true;
                  }
                } catch (error) {
                  appt.reminder.error = error.response.data;
                }
              }
            } catch (error) {
              console.log(error);
            } finally {
              this.loading = false;
            }
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }
  sendTexts() {
    this.$modal.show("dialog", {
      title: "SEND <b>TEXT</b> OPEN NOTIFICATIONS",
      text: "Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            this.$modal.hide("dialog");
            this.loading = true;
            try {
              const { checkedRows } = this;
              for (let i = 0; i < checkedRows.length; i++) {
                const appt = checkedRows[i];
                const { id } = appt;
                try {
                  const result: string = await this.$store.dispatch(
                    "schedule/sendOpenNotificationSMS",
                    { id: id, message: this.formatMessage(this.message), lang: this.lang }
                  );
                  if (result.includes("ERROR SENDING SMS")) {
                    const error = result.split(":")[1].trim();
                    appt.reminder.error = error;
                  } else {
                    appt.reminder.sent = true;
                  }
                } catch (error) {
                  appt.reminder.error = error.response.data;
                }
              }
            } catch (error) {
              console.log(error);
            } finally {
              this.loading = false;
            }
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }
  close() {
    if (this.loading) return;
    this.message = "";
    this.$root.$emit("bv::hide::popover", this.id);
    this.$store.commit("schedule/UNCHECK_PAGE_ROWS");
  }
  hide(e: BvEvent) {
    if (this.loading) e.preventDefault();
    //this.$store.commit("schedule/UNCHECK_PAGE_ROWS");
    console.log("REMINDERS_HIDDEN");
  }
  get formatPhone() {
    return formatPhone;
  }

  formatMessage(message) {
    message = message.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    message = message.replace(/[^a-zA-Z0-9 ]/g, "")
    return message;
  }


  mounted() { }
}
